/**
 * Fork overlay (new file, no OSS equivalent) — EVA-M7 (7.4).
 * The account's Eva LLM spend (/api/v1/accounts/:account_id/eva/usage → { total, by_model, cap }).
 * Singular resource: ApiClient#get already GETs this.url.
 */
import ApiClient from 'dashboard/api/ApiClient';

class EvaUsageAPI extends ApiClient {
  constructor() {
    super('eva/usage', { accountScoped: true });
  }
}

export default new EvaUsageAPI();
